import Vue from 'vue'
import store from '../store'

import VueRouter from 'vue-router'
import Index from '../views/experiment/www/Index'
import More from '../views/experiment/www/More'
import NewsDetail from '../views/experiment/www/NewsDetail'
import Search from '../views/experiment/www/Search'
import Study from '../views/experiment/www/Study'
import Ranking from '../views/experiment/www/Ranking'
import Experiment from '../views/experiment/www/Experiment'
import ExperimentV2 from '../views/experiment/www/ExperimentV2'
// import ExperimentMaintain from '../views/experiment/admin/ExperimentMaintain'
import ExperimentMaintainPart from '../views/experiment/admin/ExperimentMaintainPart'
import ExperimentTeacherMaintain from '../views/experiment/admin/ExperimentTeacherMaintain'
import Login from '../views/experiment/www/Login'
import BindPhone from '../views/experiment/www/BindPhone'
import Register from '../views/experiment/www/Register'
import FindPassword from '../views/experiment/www/FindPassword'
import ErrorPage from '../views/experiment/www/ErrorPage'
import SearchList from '../views/experiment/www/SearchList'
import Backstage from '../views/experiment/www/Backstage'
import Survey from '../views/experiment/www/Survey'
import Platform from '../views/experiment/www/Platform'
import StudyLesson from '../views/experiment/www/StudyLesson'
import ViewFile from '../views/experiment/www/ViewFile'
import ViewGrades from '../views/experiment/www/ViewGrades'

import Layout from '../views/experiment/Layout'
import Profile from '../views/experiment/user/Profile'
import PassWord from '../views/experiment/user/PassWord'
import MyExperiment from '../views/experiment/my/MyExperiment'
import MyLesson from '../views/experiment/my/MyLesson'
import MyLessonDetail from '../views/experiment/my/MyLessonDetail'
import MyLessonTest from '../views/experiment/my/MyLessonTest'
import MyScore from '../views/experiment/my/MyScore'
import MyCollection from '../views/experiment/my/MyCollection'
import MyAppraise from '../views/experiment/my/MyAppraise'
import MyMessage from '../views/experiment/my/MyMessage'

import AdminUser from '../views/experiment/admin/User'
import AdminAcademy from '../views/experiment/admin/Academy'
import AdminSchool from '../views/experiment/admin/School'
import AdminMajor from '../views/experiment/admin/Major'
import AdminExperiment from '../views/experiment/admin/ExperimentManage'
import AdminExperimentTeacher from '../views/experiment/admin/ExperimentTeacher'
import AdminViewScore from '../views/experiment/admin/viewScore'
import AdminInfo from '../views/experiment/admin/Info'
import AdminFlash from '../views/experiment/admin/Flash'
import AdminAppraise from '../views/experiment/admin/Appraise'
import AdminResourceManage from '../views/experiment/admin/ResourceManage'
import ExperimentResource from '../views/experiment/admin/ExperimentResource'
import ResourceManageUpload from '../views/experiment/admin/ResourceManageUpload'
import AdminAffirm from '../views/experiment/admin/Affirm'
import AdminSensitiveWords from '../views/experiment/admin/SensitiveWords'
import StationResearch from '../views/experiment/admin/StationResearch'
import StationResearchDetail from '../views/experiment/admin/StationResearchDetail'
import StationResearchResult from '../views/experiment/admin/StationResearchResult'
import AdminFeedBack from '../views/experiment/admin/Feedback'
import AdminLog from '../views/experiment/admin/Log'
import AdminMessage from '../views/experiment/admin/Message'

import DevLayout from '../views/experiment/develop/DevLayout'
import GetTicket from '../views/experiment/develop/GetTicket'
import DataUpload from '../views/experiment/develop/DataUpload'
import ReportUpload from '../views/experiment/develop/ReportUpload'
import OpenLogin from '../views/experiment/develop/OpenLogin'
import ExperimentApiTest from '../views/experiment/develop/ExperimentApiTest'
import TicketInfo from '../views/experiment/develop/TicketInfo'
import ExperimentReportTest from '../views/experiment/develop/ExperimentReportTest'

import ExperimentMaintainTeam from '../views/experiment/admin/maintain/ExperimentMaintainTeam'
import ExperimentMaintainDes from '../views/experiment/admin/maintain/ExperimentMaintainDes'
import ExperimentMaintainFeature from '../views/experiment/admin/maintain/ExperimentMaintainFeature'
import ExperimentMaintainFrame from '../views/experiment/admin/maintain/ExperimentMaintainFrame'
import ExperimentMaintainIntel from '../views/experiment/admin/maintain/ExperimentMaintainIntel'
import ExperimentMaintainMaterial from '../views/experiment/admin/maintain/ExperimentMaintainMaterial'
import ExperimentMaintainNet from '../views/experiment/admin/maintain/ExperimentMaintainNet'
import ExperimentMaintainPromise from '../views/experiment/admin/maintain/ExperimentMaintainPromise'
import ExperimentMaintainServicePlan from '../views/experiment/admin/maintain/ExperimentMaintainServicePlan'
import ExperimentMaintainSupport from '../views/experiment/admin/maintain/ExperimentMaintainSupport'

import LessonOnline from '../views/experiment/admin/LessonOnline'

import LessonOnlineLayout from '../views/lesson_online/LessonOnlineLayout'
import OnlineBasic from '../views/lesson_online/build/OnlineBasic'
import OnlineContent from '../views/lesson_online/build/OnlineContent'
import OnlineClass from '../views/lesson_online/build/OnlineClass'
import OnlineQuestion from '../views/lesson_online/build/OnlineQuestion'
import OnlineStudent from '../views/lesson_online/build/OnlineStudent'
import OnlineExam from '../views/lesson_online/build/OnlineExam'
import OnlineDiscuss from '../views/lesson_online/build/OnlineDiscuss'
import OnlineDiscussDetail from '../views/lesson_online/build/OnlineDiscussDetail'
import OnlineGrade from '../views/lesson_online/build/OnlineGrade'
import OnlineExperimentGrade from '../views/lesson_online/build/OnlineExperimentGrade'
import OnlineResearch from '../views/lesson_online/build/OnlineResearch'
import OnlineResearchDetail from '../views/lesson_online/build/OnlineResearchDetail'
import OnlineResearchResult from '../views/lesson_online/build/OnlineResearchResult'
import CourseStatistics from '../views/lesson_online/statistics/CourseStatistics'
import StudyStatistics from '../views/lesson_online/statistics/StudyStatistics'
import viewScore from '../views/lesson_online/statistics/viewScore'
import OnlineStudyDataProgress from '../views/lesson_online/statistics/OnlineStudyDataProgress'
import LessonOnlineDetail from '../views/lesson_online/www/LessonOnlineDetail'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Index',
    component: Index,
    meta: {
      title: '首页'
    }
  },
  {
    path: '/error',
    name: 'ErrorPage',
    component: ErrorPage,
    meta: {
      title: '错误页面'
    }
  },
  {
    path: '/www/search/res',
    name: 'SearchList',
    component: SearchList,
    meta: {
      title: '搜索结果列表'
    }
  },
  {
    path: '/www/backstage',
    name: 'Backstage',
    component: Backstage,
    meta: {
      title: '后台信息'
    }
  },
  {
    path: '/www/lesson/study',
    name: 'StudyLesson',
    component: StudyLesson,
    meta: {
      title: '学习课程'
    }
  },
  {
    path: '/www/viewfile',
    name: 'ViewFile',
    component: ViewFile,
    meta: {
      title: '查看文件'
    }
  },
  {
    path: '/www/viewgrades',
    name: 'ViewGrades',
    component: ViewGrades,
    meta: {
      title: '查看成绩'
    }
  },
  {
    path: '/login',
    name: 'Login',
    component: Login,
    meta: {
      title: '登录'
    }
  },
  {
    path: '/bindphone',
    name: 'BindPhone',
    component: BindPhone,
    meta: {
      title: '绑定手机号'
    }
  },
  {
    path: '/register',
    name: 'Register',
    component: Register,
    meta: {
      title: '注册'
    }
  },
  {
    path: '/www/search',
    name: 'Search',
    component: Search,
    meta: {
      title: '实验学习'
    }
  },
  {
    path: '/www/study',
    name: 'Study',
    component: Study,
    meta: {
      title: '课程学习'
    }
  },
  {
    path: '/www/ranking',
    name: 'Ranking',
    component: Ranking,
    meta: {
      title: '实验列表'
    }
  },
  {
    path: '/www/lesson_detail',
    name: 'LessonOnlineDetail',
    component: LessonOnlineDetail,
    meta: {
      title: '课程详情'
    }
  },
  {
    path: '/www/more',
    name: 'More',
    component: More,
    meta: {
      title: '资讯'
    }
  },
  {
    path: '/www/news/detail',
    name: 'NewsDetail',
    component: NewsDetail,
    meta: {
      title: '资讯详情'
    }
  },
  {
    path: '/www/find/password',
    name: 'FindPassword',
    component: FindPassword,
    meta: {
      title: '找回密码'
    }
  },
  {
    path: '/www/survey',
    name: 'Survey',
    component: Survey,
    meta: {
      title: '调查问卷'
    }
  },
  {
    path: '/www/platform',
    name: 'Platform',
    component: Platform,
    meta: {
      title: '平台概况'
    }
  },
  {
    path: '/my/lesson/detail',
    name: 'MyLessonDetail',
    component: MyLessonDetail,
    meta: {
      title: '我的课程-课程学习'
    }
  },
  {
    path: '/my/lesson/test',
    name: 'MyLessonTest',
    component: MyLessonTest,
    meta: {
      title: '我的课程-测试'
    }
  },
  {
    path: '/www/experiment_bak',
    name: 'Experiment',
    component: Experiment,
    meta: {
      title: '实验详情'
    },
    redirect: '/www/experiment/team',
    children: [
      {
        path: '/www/experiment/team',
        name: 'ExperimentMaintainTeam',
        component: ExperimentMaintainTeam,
        meta: {
          title: '实验信息-团队信息'
        }
      },
      {
        path: '/www/experiment/des',
        name: 'ExperimentMaintainDes',
        component: ExperimentMaintainDes,
        meta: {
          title: '实验信息-实验描述'
        }
      },
      {
        path: '/www/experiment/support',
        name: 'ExperimentMaintainSupport',
        component: ExperimentMaintainSupport,
        meta: {
          title: '实验信息-支持与服务'
        }
      },
      {
        path: '/www/experiment/net',
        name: 'ExperimentMaintainNet',
        component: ExperimentMaintainNet,
        meta: {
          title: '实验信息-网络要求'
        }
      },
      {
        path: '/www/experiment/frame',
        name: 'ExperimentMaintainFrame',
        component: ExperimentMaintainFrame,
        meta: {
          title: '实验信息-技术架构'
        }
      },
      {
        path: '/www/experiment/service_plan',
        name: 'ExperimentMaintainServicePlan',
        component: ExperimentMaintainServicePlan,
        meta: {
          title: '实验信息-服务计划'
        }
      },
      {
        path: '/www/experiment/feature',
        name: 'ExperimentMaintainFeature',
        component: ExperimentMaintainFeature,
        meta: {
          title: '实验信息-实验特色'
        }
      },
      {
        path: '/www/experiment/intel',
        name: 'ExperimentMaintainIntel',
        component: ExperimentMaintainIntel,
        meta: {
          title: '实验信息-知识产权'
        }
      },
      {
        path: '/www/experiment/promise',
        name: 'ExperimentMaintainPromise',
        component: ExperimentMaintainPromise,
        meta: {
          title: '实验信息-诚信承诺'
        }
      },
      {
        path: '/www/experiment/material',
        name: 'ExperimentMaintainMaterial',
        component: ExperimentMaintainMaterial,
        meta: {
          title: '实验信息-材料附件'
        }
      }
    ]
  },
  {
    path: '/www/experiment',
    name: 'ExperimentV2',
    component: ExperimentV2,
    meta: {
      title: '实验详情'
    }
  },
  {
    path: '/admin/experiment_maintain',
    name: 'ExperimentMaintainPart',
    component: ExperimentMaintainPart,
    meta: {
      title: '实验管理'
    },
    redirect: '/admin/experiment_maintain/team',
    children: [
      {
        path: '/admin/experiment_maintain/team',
        name: 'ExperimentMaintainTeam',
        component: ExperimentMaintainTeam,
        meta: {
          title: '实验维护-团队信息'
        }
      },
      {
        path: '/admin/experiment_maintain/des',
        name: 'ExperimentMaintainDes',
        component: ExperimentMaintainDes,
        meta: {
          title: '实验维护-实验描述'
        }
      },
      {
        path: '/admin/experiment_maintain/support',
        name: 'ExperimentMaintainSupport',
        component: ExperimentMaintainSupport,
        meta: {
          title: '实验维护-支持与服务'
        }
      },
      {
        path: '/admin/experiment_maintain/net',
        name: 'ExperimentMaintainNet',
        component: ExperimentMaintainNet,
        meta: {
          title: '实验维护-网络要求'
        }
      },
      {
        path: '/admin/experiment_maintain/frame',
        name: 'ExperimentMaintainFrame',
        component: ExperimentMaintainFrame,
        meta: {
          title: '实验维护-技术架构'
        }
      },
      {
        path: '/admin/experiment_maintain/service_plan',
        name: 'ExperimentMaintainServicePlan',
        component: ExperimentMaintainServicePlan,
        meta: {
          title: '实验维护-服务计划'
        }
      },
      {
        path: '/admin/experiment_maintain/feature',
        name: 'ExperimentMaintainFeature',
        component: ExperimentMaintainFeature,
        meta: {
          title: '实验维护-实验特色'
        }
      },
      {
        path: '/admin/experiment_maintain/intel',
        name: 'ExperimentMaintainIntel',
        component: ExperimentMaintainIntel,
        meta: {
          title: '实验维护-知识产权'
        }
      },
      {
        path: '/admin/experiment_maintain/promise',
        name: 'ExperimentMaintainPromise',
        component: ExperimentMaintainPromise,
        meta: {
          title: '实验维护-诚信承诺'
        }
      },
      {
        path: '/admin/experiment_maintain/material',
        name: 'ExperimentMaintainMaterial',
        component: ExperimentMaintainMaterial,
        meta: {
          title: '实验维护-材料附件'
        }
      }
    ]
  },
  {
    path: '/admin/experimentTeacher_maintain',
    name: 'ExperimentTeacherMaintain',
    component: ExperimentTeacherMaintain,
    meta: {
      title: '实验管理'
    }
  },
  {
    path: '/admin',
    name: 'Layout',
    component: Layout,
    meta: {
      title: '管理员后台'
    },
    redirect: '/admin/profile',
    children: [
      {
        path: '/admin/profile',
        name: 'Profile',
        component: Profile,
        meta: {
          title: '用户信息'
        }
      },
      {
        path: '/admin/password',
        name: 'PassWord',
        component: PassWord,
        meta: {
          title: '修改密码'
        }
      },
      {
        path: '/admin/my_experiment',
        name: 'MyExperiment',
        component: MyExperiment,
        meta: {
          title: '我的实验'
        }
      },
      {
        path: '/admin/my_lesson',
        name: 'MyLesson',
        component: MyLesson,
        meta: {
          title: '我的课程'
        }
      },
      {
        path: '/admin/my_score',
        name: 'MyScore',
        component: MyScore,
        meta: {
          title: '实验成绩'
        }
      },
      {
        path: '/admin/my_collection',
        name: 'MyCollection',
        component: MyCollection,
        meta: {
          title: '我的收藏'
        }
      },
      {
        path: '/admin/my_appraise',
        name: 'MyAppraise',
        component: MyAppraise,
        meta: {
          title: '我的评价'
        }
      },
      {
        path: '/admin/my_message',
        name: 'MyMessage',
        component: MyMessage,
        meta: {
          title: '我的消息'
        }
      },
      {
        path: '/admin/user',
        name: 'AdminUser',
        component: AdminUser,
        meta: {
          title: '用户管理'
        }
      },
      {
        path: '/admin/affirm',
        name: 'AdminAffirm',
        component: AdminAffirm,
        meta: {
          title: '认定管理'
        }
      },
      {
        path: '/admin/sensitive_words',
        name: 'AdminSensitiveWords',
        component: AdminSensitiveWords,
        meta: {
          title: '敏感词管理'
        }
      },
      {
        path: '/admin/station/research',
        name: 'StationResearch',
        component: StationResearch,
        meta: {
          title: '调查问卷'
        }
      },
      {
        path: '/admin/station/research/detail',
        name: 'StationResearchDetail',
        component: StationResearchDetail,
        meta: {
          title: '调查问卷-明细'
        }
      },
      {
        path: '/admin/station/research/result',
        name: 'StationResearchResult',
        component: StationResearchResult,
        meta: {
          title: '调查问卷-结果'
        }
      },
      {
        path: '/admin/school',
        name: 'AdminSchool',
        component: AdminSchool,
        meta: {
          title: '学校管理'
        }
      },
      {
        path: '/admin/academy',
        name: 'AdminAcademy',
        component: AdminAcademy,
        meta: {
          title: '院系机构管理'
        }
      },
      {
        path: '/admin/major',
        name: 'AdminMajor',
        component: AdminMajor,
        meta: {
          title: '专业分类管理'
        }
      },
      {
        path: '/admin/experiment',
        name: 'AdminExperiment',
        component: AdminExperiment,
        meta: {
          title: '实验管理'
        }
      },
      {
        path: '/admin/lesson',
        name: 'LessonOnline',
        component: LessonOnline,
        meta: {
          title: '课程管理'
        }
      },
      {
        path: '/admin/experimentTeacher',
        name: 'AdminExperimentTeacher',
        component: AdminExperimentTeacher,
        meta: {
          title: '实验管理'
        }
      },
      {
        path: '/admin/experimentViewScore',
        name: 'AdminViewScore',
        component: AdminViewScore,
        meta: {
          title: '查看成绩'
        }
      },
      {
        path: '/admin/info',
        name: 'AdminInfo',
        component: AdminInfo,
        meta: {
          title: '资讯管理'
        }
      },
      {
        path: '/admin/flash',
        name: 'AdminFlash',
        component: AdminFlash,
        meta: {
          title: '轮播图管理'
        }
      },
      {
        path: '/admin/appraise',
        name: 'AdminAppraise',
        component: AdminAppraise,
        meta: {
          title: '评价管理'
        }
      },
      {
        path: '/admin/experiment_resource',
        name: 'ExperimentResource',
        component: ExperimentResource,
        meta: {
          title: '资源管理'
        }
      },
      {
        path: '/admin/resource_manage',
        name: 'AdminResourceManage',
        component: AdminResourceManage,
        meta: {
          title: '资源管理'
        }
      },
      {
        path: '/admin/resource_manage/upload',
        name: 'ResourceManageUpload',
        component: ResourceManageUpload,
        meta: {
          title: '资源管理'
        }
      },
      {
        path: '/admin/feedback',
        name: 'AdminFeedBack',
        component: AdminFeedBack,
        meta: {
          title: '意见反馈管理'
        }
      },
      {
        path: '/admin/log',
        name: 'AdminLog',
        component: AdminLog,
        meta: {
          title: '日志管理'
        }
      },
      {
        path: '/admin/message',
        name: 'AdminMessage',
        component: AdminMessage,
        meta: {
          title: '消息管理'
        }
      }
    ]
  },
  {
    path: '/dev',
    name: 'DevLayout',
    component: DevLayout,
    redirect: '/dev/get_ticket',
    children: [
      {
        path: '/dev/get_ticket',
        name: 'GetTicket',
        component: GetTicket,
        meta: {
          title: '获取Ticket'
        }
      },
      {
        path: '/dev/data_upload',
        name: 'DataUpload',
        component: DataUpload,
        meta: {
          title: '实验结果数据回传接口'
        }
      },
      {
        path: '/dev/report_upload',
        name: 'ReportUpload',
        component: ReportUpload,
        meta: {
          title: '实验结果数据回传接口'
        }
      },
      {
        path: '/dev/open_login',
        name: 'OpenLogin',
        component: OpenLogin,
        meta: {
          title: '第三方登陆'
        }
      },
      {
        path: '/dev/experiment_api_test',
        name: 'ExperimentApiTest',
        component: ExperimentApiTest,
        meta: {
          title: '成绩上传接口模拟'
        }
      },
      {
        path: '/dev/ticket_info',
        name: 'TicketInfo',
        component: TicketInfo,
        meta: {
          title: '成绩上传接口模拟'
        }
      },
      {
        path: '/dev/experiment_report_test',
        name: 'ExperimentReportTest',
        component: ExperimentReportTest,
        meta: {
          title: '实验报告上传接口模拟'
        }
      }

    ]
  },
  {
    path: '/online',
    name: 'LessonOnlineLayout',
    component: LessonOnlineLayout,
    meta: {
      title: '在线课程'
    },
    redirect: '/online/basic',
    children: [
      {
        path: '/online/basic',
        name: 'OnlineBasic',
        component: OnlineBasic,
        meta: {
          title: '在线课程-基本信息'
        }
      },
      {
        path: '/online/content',
        name: 'OnlineContent',
        component: OnlineContent,
        meta: {
          title: '在线课程-内容管理'
        }
      },
      {
        path: '/online/content/exam',
        name: 'OnlineExam',
        component: OnlineExam,
        meta: {
          title: '在线课程-内容管理-测试维护'
        }
      },
      {
        path: '/online/class',
        name: 'OnlineClass',
        component: OnlineClass,
        meta: {
          title: '在线课程-班级管理'
        }
      },
      {
        path: '/online/question',
        name: 'OnlineQuestion',
        component: OnlineQuestion,
        meta: {
          title: '在线课程-测试题库'
        }
      },
      {
        path: '/online/student',
        name: 'OnlineStudent',
        component: OnlineStudent,
        meta: {
          title: '在线课程-选课学生'
        }
      },
      {
        path: '/online/discuss',
        name: 'OnlineDiscuss',
        component: OnlineDiscuss,
        meta: {
          title: '在线课程-答疑讨论'
        }
      },
      {
        path: '/online/discuss/detail',
        name: 'OnlineDiscussDetail',
        component: OnlineDiscussDetail,
        meta: {
          title: '在线课程-答疑讨论-详情'
        }
      },
      {
        path: '/online/grade',
        name: 'OnlineGrade',
        component: OnlineGrade,
        meta: {
          title: '在线课程-课程成绩管理'
        }
      },
      {
        path: '/online/experiment_grade',
        name: 'OnlineExperimentGrade',
        component: OnlineExperimentGrade,
        meta: {
          title: '在线课程-实验成绩管理'
        }
      },
      {
        path: '/online/research',
        name: 'OnlineResearch',
        component: OnlineResearch,
        meta: {
          title: '在线课程-调查问卷'
        }
      },
      {
        path: '/online/research/detail',
        name: 'OnlineResearchDetail',
        component: OnlineResearchDetail,
        meta: {
          title: '在线课程-调查问卷-明细'
        }
      },
      {
        path: '/online/research/result',
        name: 'OnlineResearchResult',
        component: OnlineResearchResult,
        meta: {
          title: '在线课程-调查问卷-结果'
        }
      },
      {
        path: '/online/statistics/course',
        name: 'CourseStatistics',
        component: CourseStatistics,
        meta: {
          title: '在线课程-课程统计报告'
        }
      },
      {
        path: '/online/statistics/study',
        name: 'StudyStatistics',
        component: StudyStatistics,
        meta: {
          title: '在线课程-学习数据统计'
        }
      },
      {
        path: '/online/statistics/view/achievement',
        name: 'viewScore',
        component: viewScore,
        meta: {
          title: '在线课程-学习数据统计-查看成绩'
        }
      },
      {
        path: '/online/statistics/study/progress',
        name: 'OnlineStudyDataProgress',
        component: OnlineStudyDataProgress,
        meta: {
          title: '在线课程-学习进度'
        }
      }
    ]
  }
]

const router = new VueRouter({
  mode: 'history',
  routes
})

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

router.beforeEach((to, from, next) => {
  // document.body.scrollTop = 0
  // document.documentElement.scrollTop = 0
  // window.pageYOffset = 0
  if (to.path !== '/login' && store.state.login_time) {
    const currentTime = parseInt(Date.parse(new Date()) / 1000)
    if (store.state.login_time + (60 * 60 * 12) < currentTime) {
      return next('/login')
    }
  }

  if (to.meta.title) {
    document.title = to.meta.title
  }
  if (to.path === '/login' || to.path === '/register' || to.path === '/dashboard' || to.path.substr(0, 4) === '/www' || to.path.substr(0, 4) === '/dev' || to.path === '/') return next()

  const tokenStr = store.state.token
  if (!tokenStr) return next('/login')
  next()
})

export default router
